// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"af26ede0","767":"1c6c823a"}[chunkId] + ".chunk.css";
};